import { useDispatch } from "react-redux";
import {
    setFloatingContainerState,
    setFloatingWindowState,
    setHeaderState,
    setSendMessageContainerState
} from "../../../features/componentStateSlice.js";
import minimize_icon from "/content/dam/hlb/my/chatbot/images/minus.png";

export default function MinimizeButton() {
    const dispatch = useDispatch();

    const handleMinimizeFloatingWindow = () => {
        dispatch(setFloatingContainerState(true));
        dispatch(setFloatingWindowState(false));
        dispatch(setHeaderState(false));
        dispatch(setSendMessageContainerState(false));
    };

    return (
        <button id="minimize-chat" onClick={ handleMinimizeFloatingWindow }>
            <img src={ minimize_icon } alt="minimize" className="minimize-icon" />
        </button>
    );
};
